import { formatNumber, formatUnitAbbreviation } from '@app/utils/formatting'
import { Record } from 'immutable'
import { AreaUnits } from './enums'

export interface IArea {
  readonly lotSize: number
  readonly units: AreaUnits
  toString: () => string
}

const AreaRecord = Record({
  lotSize: 0,
  units: AreaUnits.SqFt,
})

export class Area extends AreaRecord implements IArea {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Area()
    }

    const { ...rest } = initialState

    return new Area({
      lotSize: initialState.lotSize || initialState.size,
      ...rest,
    })
  }

  public readonly lotSize: number
  public readonly units: AreaUnits

  constructor(initialState?: Partial<Area>) {
    initialState ? super(initialState) : super()
  }

  public toJS() {
    return {
      size: this.lotSize,
      units: this.units,
    }
  }

  public toString(): string {
    return `${formatNumber(
      this.lotSize,
      this.units === AreaUnits.Acres ? 2 : 0,
    )} ${formatUnitAbbreviation(this.units)}`
  }
}
